import { createStore } from "vuex";

export default createStore({
  state: {
    isLoading: false,
  },
  getters: {},
  mutations: {
    setLoading(state, e) {
      state.isLoading = Boolean(e);
    },
  },
  actions: {},
  modules: {},
});
